import { Button } from "@msuite/ui/button";
import { TextInput } from "@msuite/ui/form";
import { resolver } from "@msuite/ui/libs/form";
import { useTranslation } from "@msuite/ui/localization";
import { toast } from "@msuite/ui/toast";
import { responseHandler } from "@msuite/ui/utils";
import {
	type IntegrateWebfleetFormSchema,
	integrateWebfleetFormSchema,
} from "@msuite/utils/schemas";
import { useForm } from "react-hook-form";
import { client } from "@/hono";
import type { ExtendIntegrationFormProps } from "./types";

export function IntegrationWebfleetForm({ refetch }: ExtendIntegrationFormProps) {
	/** Hooks */
	const { t } = useTranslation();
	const methods = useForm({
		resolver: resolver(integrateWebfleetFormSchema),
	});

	/** Functions */
	async function handleOnSubmit(json: IntegrateWebfleetFormSchema) {
		try {
			const response = await client.integrations.webfleet.credentials.$post({
				json,
			});
			await responseHandler(response);
			await refetch();
		} catch (error) {
			toast.error(
				error instanceof Error
					? error.message
					: "An error occurred while creating the integration.",
			);
			console.error(error);
		}
	}

	/** Render */
	return (
		<form
			className="v-stack gap-4"
			onSubmit={methods.handleSubmit(handleOnSubmit)}
		>
			<TextInput
				control={methods.control}
				name="apiKey"
				label={t("auth.api_key")}
				isRequired
				className="font-mono"
				type="password"
				placeholder={Array.from({ length: 6 })
					.map(() => "****")
					.join("-")}
			/>
			<TextInput
				control={methods.control}
				name="username"
				label={t("auth.username")}
				isRequired
				placeholder={t("placeholders.username")}
			/>
			<TextInput
				control={methods.control}
				name="account"
				label={t("auth.account")}
				isRequired
				placeholder={t("auth.account")}
			/>
			<TextInput
				control={methods.control}
				name="password"
				label={t("auth.password")}
				type="password"
				isRequired
				placeholder={t("auth.password")}
			/>
			<div className="justify-end flex flex-row">
				<Button
					variant="primary"
					isLoading={methods.formState.isSubmitting}
					type="submit"
				>
					{t("general.submit")}
				</Button>
			</div>
		</form>
	);
}
